import React from "react";

import clsx from "clsx";

import { Selector } from "@/components/inputs";
import { formatCurrency } from "@/utils/currency";

import styles from "../ProductDetailSelects.module.scss";

interface QuantitySelectorPanelProps {
  isMobile: boolean;
  quantity: number;
  options: { value: number; label: string }[];
  onChange: (quantity: number) => void;
  unit: string;
  subscriptionEnabled?: boolean;
  firstSubscriptionPrice: number;
  afterSecondSubscriptionPrice: number;
  normalPrice: number;
}

export const QuantitySelectorPanel: React.FC<QuantitySelectorPanelProps> = ({
  isMobile,
  quantity,
  options,
  onChange,
  unit,
  subscriptionEnabled,
  firstSubscriptionPrice,
  afterSecondSubscriptionPrice,
  normalPrice,
}) => {
  return (
    <dl
      className={clsx(
        styles.selectQuantity,
        "mg__top__m mg__top__s__pc mg__bottom__off__pc mg__bottom__s bg__white"
      )}
    >
      <dt>
        <span className="text__s">数量</span>
        <Selector
          id={`${isMobile ? "sp" : "pc"}_quantity_picker`}
          value={quantity}
          options={options}
          onChange={(e: number) => onChange(e)}
          className={styles.selector}
        />
        <span className={clsx(isMobile ? "text__m" : "text__s")}>{unit}</span>
      </dt>
      {subscriptionEnabled ? (
        <dd className="text__right">
          <p className={clsx("text__s", subscriptionEnabled && "text__red")}>継続コース初回価格</p>
          <p className={clsx("text__xl text__bold my-[-4px]", "text__red")}>
            {formatCurrency(firstSubscriptionPrice)}
          </p>
          <p className={clsx("text__s mg__bottom__s text__right")}>
            ２回目以降のご購入から
            {formatCurrency(afterSecondSubscriptionPrice)}
          </p>
          <p className="text__s text__gray__dark">価格は税込表示</p>
        </dd>
      ) : (
        <dd className="text__right">
          <p className={clsx("text__s", subscriptionEnabled && "text__red")}>1回のみ購入</p>
          <p className={clsx("text__xl text__bold my-[-4px]")}>{formatCurrency(normalPrice)}</p>
          {/* 全角スペースで高さを確保 */}
          <p className={clsx("text__s mg__bottom__s text__right")}>{`　`}</p>
          <p className="text__s text__gray__dark">価格は税込表示</p>
        </dd>
      )}
    </dl>
  );
};
